import { useState } from "react";
import "./styles/FallingFlowersAndHearts.css";

interface FallingFlowersAndHeartsProps {
  count?: number;
  emojis?: string[];
  notes?: string[];
}

interface Flower {
  id: number;
  emoji: string;
  left: number;      // % from left
  duration: number;  // seconds to fall
  delay: number;     // seconds before starting
  size: number;       // px
  drift: number;      // px sideways sway
  note: string;
}

const DEFAULT_EMOJIS = ["🌸", "🌺", "🌷", "🌼", "💐", "❤️", "💖", "💕", "💗", "💓"];

const DEFAULT_NOTES = [
  "عاشقتم، همیشه و برای همیشه 💕",
  "تو بهترین اتفاق زندگیمی 🌸",
  "با تو بودن قشنگ‌ترین حسه 💗",
  "هر لحظه با تو یه هدیه‌ست 🎀",
  "خوشحالم که تو رو دارم 💓",
  "تو دلیل لبخندهای منی 😊",
  "دوست دارم بیشتر از دیروز 💖",
  "با تو زندگی رنگی‌تره 🌷",
  "کیچکیلی به به 🤤",
];

const generateFlowers = (
  count: number,
  emojis: string[],
  notes: string[]
): Flower[] =>
  Array.from({ length: count }, (_, i) => ({
    id: i,
    emoji: emojis[Math.floor(Math.random() * emojis.length)],
    left: Math.random() * 100,
    duration: 6 + Math.random() * 6,
    delay: Math.random() * 8,
    size: 16 + Math.random() * 16,
    drift: Math.random() * 60 - 30,
    note: notes[Math.floor(Math.random() * notes.length)],
  }));

const FallingFlowersAndHearts: React.FC<FallingFlowersAndHeartsProps> = ({
  count = 25,
  emojis = DEFAULT_EMOJIS,
  notes = DEFAULT_NOTES,
}) => {
  const [flowers] = useState<Flower[]>(() =>
    generateFlowers(count, emojis, notes)
  );
  const [clickedIds, setClickedIds] = useState<Set<number>>(new Set());
  const [activeNote, setActiveNote] = useState<string | null>(null);

  const handleFlowerClick = (flower: Flower) => {
    setActiveNote(flower.note);
    setClickedIds((prev) => new Set(prev).add(flower.id));
  };

  return (
    <>
      <div className="falling-flowers">
        {flowers.map((flower) => (
          <span
            key={flower.id}
            className={`falling-flower${
              clickedIds.has(flower.id) ? " falling-flower--clicked" : ""
            }`}
            style={
              {
                left: `${flower.left}%`,
                fontSize: `${flower.size}px`,
                animationDuration: `${flower.duration}s`,
                animationDelay: `${flower.delay}s`,
                "--drift": `${flower.drift}px`,
              } as React.CSSProperties
            }
            onClick={() => handleFlowerClick(flower)}
          >
            {flower.emoji}
          </span>
        ))}
      </div>

      {activeNote && (
        <div className="love-note-overlay" onClick={() => setActiveNote(null)}>
          <div className="love-note-card" onClick={(e) => e.stopPropagation()}>
            <button
              className="love-note-close"
              onClick={() => setActiveNote(null)}
              aria-label="Close"
            >
              ×
            </button>
            <p className="love-note-text">{activeNote}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default FallingFlowersAndHearts;